import { reactive, computed } from "vue"

export function createPathStore(apiKey) {
  const state = reactive({
    itemsByPath: {},
    fetchByPath: {},
    currentPath: null,
  })

  async function fetchForPath(path) {
    if (state.fetchByPath[path] === true) return
    if (state.fetchByPath[path] instanceof Promise) return state.fetchByPath[path]

    const promise = fetch(`${path}.json?view=vue`)
      .then(async r => {
        if (!r.ok) throw new Error(`Failed to fetch ${apiKey} for ${path}`)
        const data = await r.json()
        state.itemsByPath[path] = data[apiKey]
        state.fetchByPath[path] = true
      })
      .catch(err => {
        delete state.fetchByPath[path]
        throw err
      })

    state.fetchByPath[path] = promise
    return promise
  }

  return reactive({
    items: computed(() => state.itemsByPath[state.currentPath] ?? []),

    pathState: computed(() => {
      if ( state.currentPath == undefined ) {
        return "init"
      }

      const v = state.fetchByPath[state.currentPath]
      if ( v == true ) {
        return "loaded"
      } else if ( v instanceof Promise ) {
        return "loading"
      } else {
        return "init"
      }
    }),
    setPath(path) {
      state.currentPath = path
      if (!(path in state.itemsByPath)) {
        fetchForPath(path)
      }
    },
    currentPath: state.currentPath,
    init(initialData) {
      const initialPath = window.location.pathname
      Object.assign(state, {
        currentPath: initialPath,
        itemsByPath: {},
        fetchByPath: {}
      })

      if ( initialData === null || initialData === undefined ) {
        fetchForPath(initialPath)
      } else {
        state.itemsByPath[initialPath] = initialData
        state.fetchByPath[initialPath] = true
      }
    }
  })
}

export const mixesStore = createPathStore('mixes')
export const playlistStore = createPathStore('playlist')
